import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';


const mapStateToProps = (state: State) => {
  const { remoteConfig } = state;
  return {
    socialLinksEnabled: remoteConfig?.switches.socialLinksEnabled,
    socialLinks: remoteConfig?.configs.socialLinks,
  };
};

export default connect(mapStateToProps)(View);
